import { type FC } from 'react';
import styles from '../styles/time-selection.module.scss';
import AttentionNotice from '../components/attention-notice';
import TimePicker from '../components/time-picker';
import ActionButton from '../components/action-button';
import PageTitle from '../components/page-title';
import { formatDayLabel } from '../utils/helpers';
import type { AppointmentSlot } from '../models/repair-bookings';

const TimeSelection: FC<{
    className?: string;
    selectedDate: string;
    slots: AppointmentSlot[];
    onComplete: (slot: AppointmentSlot) => void;
    onCancel: () => void;
}> = ({ className, selectedDate, slots, onComplete, onCancel }) => {
    return (
        <div className={`${styles.timeSelection} ${className}`}>
            <PageTitle title="予約する時間を選んでください" />
            <TimePicker
                className={styles.timePicker}
                day={formatDayLabel(selectedDate)}
                slots={slots}
                onSlotSelect={(slot) => onComplete(slot)}
            />
            <AttentionNotice messages={['○：予約可　×：予約不可']} />
            <ActionButton
                className={styles.backButton}
                title="戻る"
                primary={false}
                onClick={onCancel}
            />
        </div>
    );
};

export default TimeSelection;
